import moment from 'moment';
import TEXT from './text';

const sortDateCompare = order => (a, b) =>
  moment(a)
    .subtract(b)
    .unix() * (order === 'asc' ? 1 : -1);
/**
 * @type {import('mui-datatables').MUIDataTableColumnDef[]}
 */
const DEFAULT_COLUMNS = [
  {
    name: '_id',
    options: {
      display: 'excluded',
      sort: false,
      filter: false
    }
  },
  {
    name: 'location',
    label: TEXT.tableCellHeader.location
  },
  {
    name: 'createdAt',
    label: TEXT.tableCellHeader.createdAt,
    options: {
      customBodyRender: value => (value ? moment(value).format('DD.MM.YYYY') : ''),
      sortCompare: sortDateCompare
    }
  },
  {
    name: 'title',
    label: TEXT.tableCellHeader.title
  },
  {
    name: 'firstName',
    label: TEXT.tableCellHeader.firstName
  },
  {
    name: 'lastName',
    label: TEXT.tableCellHeader.lastName
  },
  {
    name: 'mail',
    label: TEXT.tableCellHeader.mail
  },
  {
    name: 'phoneNumber',
    label: TEXT.tableCellHeader.phoneNumber
  },
  {
    name: 'birthDate',
    label: TEXT.tableCellHeader.birthDate,
    options: {
      customBodyRender: value => moment.utc(value).format('DD.MM.YYYY'),
      sortCompare: sortDateCompare
    }
  },
  {
    name: 'street',
    label: TEXT.tableCellHeader.street
  },
  {
    name: 'postalCode',
    label: TEXT.tableCellHeader.postalCode
  },
  {
    name: 'city',
    label: TEXT.tableCellHeader.city
  },
  {
    name: 'keycloakId',
    options: {
      display: 'excluded',
      sort: false,
      filter: false
    }
  },
  {
    name: 'Aktionen',
    options: {
      display: true,
      filter: false
    }
  }
];

const applicantColumns = {
  DEFAULT_COLUMNS
};

export default applicantColumns;
